<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon class="header-icon" fontIcon="smart_display"></mat-icon>
        Timelapse
    </h1>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<ng-container
    *ngIf="project() && displayIframe; else elseBlock">
    <div class="timelapse-container">
        <iframe [src]="timelapseGoUrl" height="100%" width="100%"></iframe>
    </div>
</ng-container>

<ng-template #elseBlock>
    <div class="p-else">
        <h2>
            Des clichés à intervalle régulier pour suivre vos sites comme si vous y étiez
        </h2>

        <h3>
            Des boîtiers photos reflex ultra Haute Définition connectés à une interface de suivi personnalisée
            accessible en temps réel.
        </h3>

        <h3>
            Pour plus d’information contacter notre service client
        </h3>

        <div class="input-timelapse">
            Pour acceder à votre espace Timelaspe, veuillez renseigner votre url dans les paramètres de projet.
            <lib-button color="secondary" type="submit" icon="settings" text="Paramètres de projet" (click)="openProjectSettings()">
            </lib-button>
        </div>
    </div>
</ng-template>